//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/**
* TODO: Get rid of this enum? It's used only to double-convert strings from frontend.
*               TODO: With new commissions only one value of this enum is used, and even the string values are different!
*                 Or reuse with <see cref="T:mpsklad_core.Entity.YandexMarket.Enums.YandexMarketOrderCommissionType" />?
*               Типы удержаний
*/
export enum MoySkladOrderFeeType {
  /** Комиссия */
  Commission = 0,
  /** Размещение товара на маркетплейсе */
  Fee = 1,
  /** Плата за участие в программе лояльности */
  LoyaltyParticipationFee = 2,
  /** Доставка покупателю (FBY, FBS). Для DBS и Экспресс — если заказ возвращается через логистику Маркета. */
  DeliveryToCustomer = 3,
  /** Экспресс-доставка покупателю (Экспресс). */
  ExpressDeliveryToCustomer = 4,
  /** Плата за буст продаж */
  AuctionPromotion = 5,
  /** Прием платежа покупателя */
  Agency = 6,
  /** Перевод платежа покупателя */
  PaymentTransfer = 7,
  /** Хранение невыкупов и возвратов (FBS). Для DBS и Экспресс — если заказ возвращается через логистику Маркета. */
  ReturnedOrdersStorage = 8,
  /** Обработка заказа (FBS) */
  Sorting = 9,
  /** Организация забора заказов со склада продавца (FBS). */
  IntakeSorting = 10,
  /** Обработка заказов на складе (FBS). Для DBS и Экспресс — если заказ возвращается через логистику Маркета. */
  ReturnProcessing = 11,
  /** Вознаграждение за продажу невывезенных товаров */
  IlliquidGoodsSale = 12
}
